// React hooks
import { useEffect, useState } from "react";

// Componentes react-bootstrap
import { Container, Button } from "react-bootstrap";

// React-icons
import { IoMdAdd } from "react-icons/io";

// Componentes
import AdminGeoServicios from "./forms/AdminGeoServicios";
import AdminAplicacion from "./forms/AdminAplicacion";
import AdminDocumento from "./forms/AdminDocumento";
import AdminGrupos from "./forms/AdminGrupos";
import { AdminVideo } from "./forms/Ayudas/AdminVideo";
import { AdminPregunta } from "./forms/Ayudas/AdminPregunta";
import { AdminManual } from "./forms/Ayudas/AdminManual";
import { AdminDatoAbierto } from "./forms/AdminDatoAbierto";
import AdminNoticia from "./forms/AdminNoticia";

export default function OpenModal({
  componentes,
  idComponente,
  caractFiltro,
  tituloAdmin,
  ayudasGet,
  infoUser,
  permissions,
  setLoad,
}) {
  // Estado modal
  const [show, setShow] = useState(false);
  // Cerrar modal
  const handleClose = () => {
    setShow(false);
  };
  // Abrir modal
  const handleShow = () => setShow(true);

  // renderiza el modal segun el componente
  const renderModal = () => {
    // forms object componentes
    const componentesForm = {
      1: (
        <AdminGeoServicios
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={show}
          onHide={() => handleClose()}
          tituloModal={tituloAdmin}
          accion={"Nuevo"}
        />
      ),
      2: (
        <AdminDatoAbierto
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={show}
          onHide={() => handleClose()}
          tituloModal={tituloAdmin}
          accion={"Nuevo"}
          infoUser={infoUser}
        />
      ),
      3: (
        <AdminDocumento
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={show}
          onHide={() => handleClose()}
          tituloModal={tituloAdmin}
          accion={"Nuevo"}
        />
      ),
      4: (
        <>
          <AdminVideo
            caractFiltro={caractFiltro}
            idComponente={idComponente}
            show={
              idComponente === 4 && tituloAdmin === "Nuevo Video" ? show : false
            }
            onHide={() => handleClose()}
            tituloModal={tituloAdmin}
            accion={"Nuevo"}
            listAyudas={ayudasGet}
            setLoad={setLoad}
          />
          <AdminManual
            caractFiltro={caractFiltro}
            idComponente={idComponente}
            show={
              idComponente === 4 && tituloAdmin === "Nuevo Manual"
                ? show
                : false
            }
            onHide={() => handleClose()}
            tituloModal={tituloAdmin}
            accion={"Nuevo"}
            listAyudas={ayudasGet}
            setLoad={setLoad}
          />
          <AdminPregunta
            caractFiltro={caractFiltro}
            idComponente={idComponente}
            show={
              idComponente === 4 && tituloAdmin === "Nueva Pregunta"
                ? show
                : false
            }
            onHide={() => handleClose()}
            tituloModal={tituloAdmin}
            accion={"Nuevo"}
            listAyudas={ayudasGet}
            setLoad={setLoad}
          />
        </>
      ),
      5: (
        <AdminAplicacion
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={show}
          onHide={() => handleClose()}
          tituloModal={tituloAdmin}
          accion={"Nuevo"}
          permissions={permissions}
          infoUser={infoUser}
        />
      ),
      7: (
        <AdminNoticia
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={show}
          onHide={() => handleClose()}
          tituloModal={tituloAdmin}
          accion={"Nuevo"}
          handleLoad={setLoad}
        />
      ),
      12: (
        <AdminGrupos
          caractFiltro={caractFiltro}
          idComponente={idComponente}
          show={show}
          setShow={setShow}
          onHide={() => handleClose()}
          tituloModal={tituloAdmin}
          accion={"Nuevo"}
          infoUser={infoUser}
          permissions={permissions}
        />
      ),
    };

    // retorna el modal segun el componente en el que se este
    return componentesForm[idComponente];
  };
  return (
    <>
      <Container fluid={true}>
        <div className="container-admin-register">
          <Button
            className="btn-geomedellin btn-register-admin"
            onClick={handleShow}
            id="button-register_openModal"
          >
            <i className="me-1">
              <IoMdAdd color="#fff" size={"13px"} />
            </i>
            {tituloAdmin}
          </Button>
        </div>
      </Container>

      {renderModal()}
    </>
  );
}
